export const ROLES = {
  Admin: "Admin",
  Manager: "Quản lý",
  Saler: "Saler",
  Accountant: "Kế toán",
  Designer: "Thiết kế",
  Printer: "In ấn",
  Store: "Kho",
  Deliver: "Giao hàng",
};
